import {
  SearchIcon,
  FilterList,
  CalenderIcon,
} from "../../../../../public/assets";
import EmptyDashBoard from "../../../../components/DashBoardComponents/EmptyDashBoard";
import UserManagementHeader from "../../UserManagementHeader";
import UserTextHeader from "../../UserManagementHeader/UserTextHeader";
import {
  UserProfileHeader,
  UserProfileMain,
  UserProfileSubHeader,
  UserProfileFilterButton,
  SearchIconStyled,
  StyledInput,
  UserProfileSearch,
  UserProfileActivityTable,
  UserProfileActivityTypes,
  UserProfileActivityTime,
  UserProfileActivityCalenderTime,
  UserProfileTitleName,
  UserProfileTitleRole,
  UserProfileTitleStatus,
  UserProfileTitleLast,
  UserProfileTitleAction,
  UserProfileEmptyDashboard,
  UserProfileSpan,
  Status,
} from "./UserProfile.styles";

import {
  getAllRoles,
  getAllUsersByOrganizationId,
} from "../../../../graphql/queries/userManagement";
import { useMutation, useQuery } from "@apollo/client";
import UserProfileContent, { userContent } from "./UserProfilleContent";
import {
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
} from "@mui/material";
import { useEffect, useState } from "react";
import DropdownFilter from "./DropdownMenu";
import SelectAllModal from "./SelectAllModal";
import { RootState } from "../../../../store/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import {
  reassignMultipleUsersRole,
  reassignUserRole,
} from "../../../../graphql/mutations/userManagement";
import { setLoading } from "../../../../store/loadingSpinner";
import { setUserData } from "../../../../store/user";
import { setSelectedRole } from "../../../../store/userManagement";
import ReassignRoleOtpModal from "./ReassignRoleOtpModal";
import { toast } from "react-toastify";

const UserProfile: any = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user?.user);
  const { selectedRole } = useSelector(
    (state: RootState) => state.userManagement
  );
  const { isLoading } = useSelector((state: RootState) => state.loadingSpinner);
  const { organizationId, id, otp } = user;
  const {
    loading,
    data,
    refetch: refetchUsers,
  } = useQuery(getAllUsersByOrganizationId);
  const users = data?.getAllUsersByOrganizationId || [];

  const { data: roleData } = useQuery(getAllRoles);
  const rolesFetched = roleData?.getAllRoles.data || [];

  const [filteredUsers, setFilteredUsers] = useState<userContent[]>([]);
  const [currentStatus, setCurrentStatus] = useState<string>("All");
  const [showFilterDropdown, setShowFilterDropDown] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [action, setAction] = useState<string>("");
  const [currentIndex, setCurrentIndex] = useState<number>(-1);
  const [updatedRole, setUpdatedRole] = useState(false);
  const [multipleRole, setMultipleRole] = useState("");
  const [multipleSelection, setMultipleSelection] = useState("");
  const [selectedUsers, setSelectedUsers] = useState<userContent[]>([]);
  const [otpRequired, setOtpRequired] = useState(false);
  const [reassignUserRoleMutation] = useMutation(reassignUserRole);
  const [searchInput, setSearchInput] = useState("");
  const [reassignMultipleUsersRoleMutation] = useMutation(
    reassignMultipleUsersRole
  );

  const handleSearch = (searchText: string) => {
    setSearchInput(searchText);
    if (!searchText.trim()) {
      setFilteredUsers(
        users?.map((user: userContent) => ({
          ...user,
          isChecked: isChecked ? true : false,
          role: rolesFetched.find(
            (item: { id: string }) => item.id === user?.organization_role_id
          )?.name,
        }))
      );
    } else {
      setFilteredUsers(
        users
          ?.filter((user: { firstName: string }) =>
            user?.firstName
              ?.toLowerCase()
              ?.startsWith(searchText?.toLowerCase())
          )
          .map((user: { organization_role_id: any }) => ({
            ...user,
            role: rolesFetched.find(
              (item: { id: any }) => item.id === user.organization_role_id
            )?.name,
            isChecked: isChecked ? true : false,
          }))
      );
    }
  };

  const handleFilter = (status: string, searchName: string) => {
    setCurrentStatus(status);
    setFilteredUsers((prevUsers) => {
      const newArr = [...users].map((user: userContent) => ({
        ...user,
        isChecked: isChecked ? true : false,
        role: rolesFetched.find(
          (item: { id: string }) => item.id === user.organization_role_id
        )?.name,
      }));

      let filteredArr = newArr;
      if (status !== "All") {
        filteredArr = newArr?.filter((user) => user.status === status);
      }
      if (searchName.trim() !== "") {
        filteredArr = filteredArr?.filter(
          (user) =>
            user.fullName &&
            user.fullName?.toLowerCase().includes(searchName.toLowerCase())
        );
      }
      return filteredArr;
    });
  };

  const toggleFilterDropDown = () => {
    setShowFilterDropDown(!showFilterDropdown);
  };

  const handleCheckboxChange = (index: number, e: any) => {
    const newArr = [...filteredUsers];
    const requiredData = newArr[index];
    requiredData.isChecked = e?.target?.checked;
    newArr[index] = requiredData;
    setFilteredUsers(newArr);
    setMultipleSelection("multiple");
    const users = selectedUsers?.filter(({ id }) => id !== requiredData.id);
    setSelectedUsers([...users, requiredData]);
  };

  const booleanArr = filteredUsers?.filter((item) => item.isChecked);

  const handleClickAction = (text: string) => {
    setAction((prevAction) => (text === prevAction ? "" : text));
  };

  const handleCurrentIndex = (index: number) => {
    setCurrentIndex((prevIndex) => (index === prevIndex ? -1 : index));
  };

  const handleSelect = async (role: string, index?: number) => {
    setCurrentIndex(index!);
    dispatch(setSelectedRole(role === "Administrator" ? "" : role));
    if (role === "Administrator") {
      await handleOtpSubmit("", index!);
    }
  };
  const handleOtpSubmit = async (val?: string, index?: number) => {
    const selectedUser = users[currentIndex < 0 ? index! : currentIndex];
    const payload = {
      userId: selectedUser?.id,
      accountHolderId: id,
      newRoleId: rolesFetched.find(
        (item: { name: string }) =>
          item.name === (selectedRole || "Administrator")
      )?.id,
      otp: otp?.join(""),
    };

    dispatch(setLoading(true));
    setUpdatedRole(false);

    try {
      const response = await reassignUserRoleMutation({
        variables: payload,
      });
      if (
        response?.data?.reassignRoleForAUser?.message ===
        "OTP has been sent to your email. Proceed to verify your email."
      ) {
        dispatch(setSelectedRole("Administrator"));
        setOtpRequired(true);
        setUpdatedRole(false);
      } else {
        setOtpRequired(false);
        dispatch(setSelectedRole(""));
        toast.success("Successfully updated a user's role.");
      }
      await refetchUsers();
    } catch (error) {
      setUpdatedRole(false);
      console.error("Error reassigning user:", error);
    } finally {
      dispatch(setLoading(false));
      dispatch(setUserData({ ...user, otp: [] }));
    }
  };

  const handleMultipleRoles = async (role: { type: string; name: string }) => {
    setAction("");
    setMultipleRole(role.name === "Administrator" ? "" : role.name);
    dispatch(setSelectedRole(role.name));
    if (role.name === "Administrator") {
      await handleMultipleRoleReassign();
    }
  };

  const handleMultipleRoleReassign = async () => {
    try {
      dispatch(setLoading(true));
      const response = await reassignMultipleUsersRoleMutation({
        variables: {
          userRoles: selectedUsers.map((user) => ({
            newRoleId: rolesFetched.find(
              (item: { name: string }) =>
                item.name === (multipleRole || "Administrator")
            )?.id,
            userId: user.id,
          })),
          accountHolderId: id,
          otp: otp?.join(""),
        },
      });

      if (
        response?.data?.reassignRolesForMultipleUsers?.message ===
        "OTP has been sent to your email. Proceed to verify your email."
      ) {
        setOtpRequired(true);
        setUpdatedRole(false);
        if (!multipleRole) {
          setMultipleRole("Administrator");
          dispatch(setSelectedRole("Administrator"));
        }
      } else {
        setOtpRequired(false);
        dispatch(setSelectedRole(""));
        setMultipleRole("");
        setUpdatedRole(multipleRole !== "Administrator");
      }

      multipleRole && toast.success("Successfully updated users' roles.");
      await refetchUsers();
    } catch (error) {
      console.error("Error reassigning user:", error);
    } finally {
      dispatch(setLoading(false));
      dispatch(setUserData({ ...user, otp: [] }));
    }
  };

  const handleCloseOtpModal = async () => {
    dispatch(setSelectedRole(""));
    setCurrentIndex(-1);
    dispatch(setLoading(false));
    window.location.reload();
  };
  useEffect(() => {
    const newArr = [...users].map((user: userContent) => ({
      ...user,
      isChecked: !!isChecked,
      role: rolesFetched?.find(
        (item: { id: string }) => item.id === user?.organization_role_id
      )?.name,
    }));
    setFilteredUsers(newArr);
    (async () => await refetchUsers())();
  }, [
    loading,
    isLoading,
    isChecked,
    organizationId,
    rolesFetched?.length,
    updatedRole,
  ]);
  useEffect(() => {
    updatedRole && dispatch(setSelectedRole("")) && setSelectedUsers([]);
  }, [isLoading]);
  return (
    <div>
      <UserTextHeader />
      <UserManagementHeader />
      <div style={{ width: "77vw", paddingLeft: "20px" }}>
        <UserProfileMain>
          <UserProfileHeader>
            <UserProfileSubHeader>
              <UserProfileSpan>Users Profile</UserProfileSpan>
              <UserProfileSearch>
                <SearchIconStyled src="/assets/svg/Search.svg" />
                <StyledInput
                  type="text"
                  placeholder="Search history by name"
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </UserProfileSearch>
            </UserProfileSubHeader>
            <UserProfileFilterButton style={{ position: "relative" }}>
              <img
                src="/assets/svg/Filter list.svg"
                alt="Search"
                style={{ paddingRight: "8px" }}
                onClick={toggleFilterDropDown}
              />
              <span>Filter by</span>
              {showFilterDropdown && (
                <div
                  style={{
                    position: "absolute",
                    top: "140%",
                    right: "30px",
                    width: "200px",
                  }}
                >
                  <DropdownFilter />
                </div>
              )}
            </UserProfileFilterButton>
          </UserProfileHeader>
          <UserProfileActivityTable>
            <UserProfileActivityTypes>
              <Status
                $active={currentStatus === "All"}
                onClick={() => handleFilter("All", "")}
              >
                All
              </Status>
              <Status
                $active={currentStatus === "active"}
                onClick={() => handleFilter("active", "")}
              >
                Active
              </Status>
              <Status
                $active={currentStatus === "inactive"}
                onClick={() => handleFilter("inactive", "")}
              >
                Pending
              </Status>
              <Status
                $active={currentStatus === "Disabled"}
                onClick={() => handleFilter("Disabled", "")}
              >
                Disabled
              </Status>
            </UserProfileActivityTypes>
            <UserProfileActivityCalenderTime>
              <img src="/assets/svg/calendar.svg" alt="calender icon" />
              <UserProfileActivityTime>
                Updated, <span>Dec 08, 2023</span>
              </UserProfileActivityTime>
            </UserProfileActivityCalenderTime>
          </UserProfileActivityTable>
          {booleanArr?.length > 0 && (
            <SelectAllModal
              isChecked={isChecked}
              handleCheckboxChange={() => setIsChecked(!isChecked)}
              count={booleanArr?.length}
              handleClickAction={handleClickAction}
              clickedAction={action}
              roles={rolesFetched}
              onRoleChange={handleMultipleRoles}
            />
          )}
          <TableContainer component={Paper} sx={{ width: "100%" }}>
            <Table sx={{ width: "100%" }}>
              <TableBody sx={{ width: "100%" }}>
                <TableHead
                  sx={{
                    width: "100%",
                    backgroundColor: "#f7f7f7",
                    border: "1px solid #e8eaed",
                  }}
                >
                  <TableCell sx={{ width: "35%" }}>
                    <UserProfileTitleName>Name</UserProfileTitleName>
                  </TableCell>
                  <TableCell sx={{ width: "20%" }}>
                    <UserProfileTitleRole>Role</UserProfileTitleRole>
                  </TableCell>
                  <TableCell sx={{ width: "15%" }}>
                    <UserProfileTitleStatus>Status</UserProfileTitleStatus>
                  </TableCell>
                  <TableCell sx={{ width: "25%" }}>
                    <UserProfileTitleLast>
                      Last Activity Date
                    </UserProfileTitleLast>
                  </TableCell>
                  <TableCell sx={{ width: "5%" }}>
                    <UserProfileTitleAction>Action</UserProfileTitleAction>
                  </TableCell>
                </TableHead>
                <div>
                  {filteredUsers?.length === 0 ? (
                    <>
                      {loading && (
                        <EmptyDashBoard
                          titleText="Loading users..."
                          subtitleText=""
                          specialStyle={true}
                        />
                      )}
                      {!loading && (
                        <UserProfileEmptyDashboard>
                          <EmptyDashBoard
                            titleText="No User History"
                            subtitleText="All users history will be displayed here"
                            specialStyle={true}
                          />
                        </UserProfileEmptyDashboard>
                      )}
                    </>
                  ) : (
                    <div style={{ width: "100%" }}>
                      {loading && filteredUsers?.length === 0 && (
                        <EmptyDashBoard
                          titleText="Loading users..."
                          subtitleText=""
                          specialStyle={true}
                        />
                      )}
                      {filteredUsers?.length > 0 && (
                        <>
                          {filteredUsers
                            ?.sort((a, b) => {
                              const roleAdministrator = a.role?.toLowerCase();
                              const roleBasic = b.role?.toLowerCase();
                              if (roleAdministrator < roleBasic) return -1;
                              if (roleAdministrator > roleBasic) return 1;
                              return 0;
                            })
                            .map((user: userContent, index: number) => (
                              <UserProfileContent
                                key={user.id}
                                data={user}
                                handleCheckboxChange={handleCheckboxChange}
                                index={index}
                                showDropDown={index === currentIndex}
                                handleShowDropDown={handleCurrentIndex}
                                roles={rolesFetched}
                                onRoleChange={handleSelect}
                                handleCloseOtpModal={handleCloseOtpModal}
                              />
                            ))}
                        </>
                      )}
                    </div>
                  )}
                </div>
              </TableBody>
            </Table>
          </TableContainer>
        </UserProfileMain>
      </div>
      <>
        {(!!selectedRole || !!multipleRole) && (
          <ReassignRoleOtpModal
            onClose={handleCloseOtpModal}
            onSubmit={
              multipleSelection === "multiple"
                ? handleMultipleRoleReassign
                : handleOtpSubmit
            }
          />
        )}
      </>
    </div>
  );
};
export default UserProfile;
